import React, { useEffect, useState } from "react"
import styles from "../MessengerIntegration/messengerIntegration.module.css"
import Button from '../../components/Form/Button'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { AiOutlineDisconnect } from "react-icons/ai"
import { MdHistory, MdOpenInNew, MdOutlineCheck } from "react-icons/md"
import { RiInstagramLine } from 'react-icons/ri'
import FormGroup from '../../components/Form/FormGroup'
import DatePicker from "../../components/Form/DatePicker"
import Select from "../../components/Form/Select"
import Modal from "../../components/Modal"
import ModalConfirm from "../../components/Modal/ModalConfirm"
import Loading from '../layouts/Loading'
import { useData } from "../../contexts/dataContext"
import ModalInbox from "../../components/Modal/ModalInbox"
import ImageWithFallback from "../../components/ImageWithFallback"
import BackButton from "../../components/BackButton"
import { useParams, useSearchParams } from "react-router-dom"
import InboxCard from "../../components/InboxCard"
import InfoTooltip from "../../components/InfoTooltip"

const ASSIGNMENT_SOURCE_OPTIONS = [
    { id: "new_conversation", value: "Nova conversa" },
    { id: "manual", value: "Manual" },
    { id: "management", value: "Gestão em massa" },
    { id: "bulk_action", value: "Ação em lote" },
    { id: "ai_handoff", value: "IA para humano" },
    { id: "access_request", value: "Liberação de acesso" },
    { id: "chat_start", value: "Início de atendimento" },
]

const ASSIGNMENT_SOURCE_TOOLTIP = "Nova conversa é a atribuição aplicada na chegada do atendimento. Manual é feita por uma pessoa no chat. Gestão em massa usa filtros para alterar conversas. Ação em lote usa conversas selecionadas manualmente. IA para humano ocorre em transferência do agente. Liberação de acesso registra aprovações de acesso. Início de atendimento registra quando alguém assume ao abrir."

const getDefaultAssignmentFilters = () => ({ dateStart: "", dateEnd: "", sources: [] })
const formatNumber = (value = 0) => Number(value || 0).toLocaleString("pt-BR")
const formatDateTime = (date) => date ? new Date(date).toLocaleString("pt-BR") : "-"

const InstagramDirectIntegration = () => {
    const [linkedAccounts, setLinkedAccounts] = useState([])
    const [availableAccounts, setAvailableAccounts] = useState([])
    const [showModalDisconect, setShowModalDisconect] = useState(false)
    const [showModalConfirm, setShowModalConfirm] = useState(false)
    const [showModalAccount, setShowModalAccount] = useState(false)
    const [accountDisconect, setAccountDisconect] = useState({})
    const [accountConect, setAccountConect] = useState({})
    const [accountConfig, setAccountConfig] = useState({})
    const [users, setUsers] = useState([])
    const [chatBots, setChatBots] = useState([])
    const [hasLoadingAvailable, setHasLoadingAvailable] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showAssignmentHistoryModal, setShowAssignmentHistoryModal] = useState(false)
    const [assignmentHistoryInbox, setAssignmentHistoryInbox] = useState({})
    const [assignmentHistory, setAssignmentHistory] = useState({ assignments: [], pagination: {} })
    const [assignmentHistoryFilters, setAssignmentHistoryFilters] = useState(getDefaultAssignmentFilters())
    const [isLoadingAssignmentHistory, setIsLoadingAssignmentHistory] = useState(false)

    const { teams, roles, allUsersGroup, funnels, loadFunnels } = useData()
    const { account_id } = useParams()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        getAllLinkedAccounts()
        getAllChatBots()
        loadFunnels()
    }, [])

    useEffect(() => {
        setUsers(allUsersGroup?.map(user => ({ id: user?._id, value: user?.name, teams: user?.teams?.map(team => team?.team_id || team) || [] })))
    }, [allUsersGroup])

    useEffect(() => {
        if (searchParams.get("instagram_login") !== "success") return

        toast.success("Login do Instagram concluído. Selecione a conta disponível para conectar.")
        getAllNotLinkedAccounts()
        setSearchParams({}, { replace: true })
    }, [searchParams, setSearchParams])

    const getAllLinkedAccounts = () => {
        setIsLoading(true)
        api.get("/integrations/instagram/accounts/linked").then(response => {
            setLinkedAccounts(response?.data?.data || [])
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const getAllNotLinkedAccounts = () => {
        setIsLoading(true)
        api.get("/integrations/instagram/accounts/available").then(response => {
            const accounts = response?.data?.data || []
            const listAvailableAccounts = accounts?.filter(availableAccount => !linkedAccounts.some(linkedAccount => linkedAccount?.metadata?.instagram_id === availableAccount.instagram_id))
            setAvailableAccounts(listAvailableAccounts)
            setHasLoadingAvailable(true)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleCloseModalConfirm = () => {
        setAccountConect({})
        setShowModalConfirm(false)
    }

    const handleConectAccount = (account) => {
        setIsLoading(true)
        api.post("/integrations/instagram/connectAccount", account).then(response => {
            const newAccount = response?.data?.data
            if (newAccount) {
                setLinkedAccounts(previousValue => [...previousValue, newAccount])
                setAvailableAccounts(previousValue => previousValue?.filter(el => newAccount?.metadata?.instagram_id !== el?.instagram_id))
            }
            handleCloseModalConfirm()
            handleShowModalAccount(newAccount._id)
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleCloseModalDisconect = () => {
        setAccountDisconect({})
        setShowModalDisconect(false)
    }

    const handleDisconectAccount = (account) => {
        setIsLoading(true)
        api.post("/integrations/instagram/disconnectAccount", { inbox_id: account._id }).then(response => {
            setLinkedAccounts(previousValue => previousValue?.filter(el => el._id !== account._id))
            handleCloseModalDisconect()
            setHasLoadingAvailable(false)
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleRefreshToken = (account) => {
        setIsLoading(true)
        api.post(`/integrations/instagram/accounts/${account._id}/refresh-token`, { account_id }).then(response => {
            const tokenStatus = response?.data?.data
            setLinkedAccounts(previousValue => previousValue.map(inbox => {
                if (inbox?._id !== account._id) return inbox
                return {
                    ...inbox,
                    metadata: {
                        ...(inbox.metadata || {}),
                        instagram_token: tokenStatus,
                        instagram_token_status: tokenStatus?.status,
                        instagram_reconnect_required: tokenStatus?.reconnect_required,
                    }
                }
            }))
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message || "Não foi possível renovar o token. Faça a reconexão."))
            .finally(() => setIsLoading(false))
    }

    const handleShowModalAccount = (accountId) => {
        setIsLoading(true)
        api.get(`/integrations/instagram/accounts/${accountId}`).then(response => {
            setAccountConfig(response?.data?.data || {})
            setShowModalAccount(true)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleCloseModalAccount = () => {
        setAccountConect({})
        setShowModalAccount(false)
    }

    const handleUpdateAccount = (data) => {
        setIsLoading(true)
        api.patch(`/integrations/instagram/accounts/${data?._id}`, data).then(response => {
            const account = response.data.data
            updateAccountByContent(account)
            handleCloseModalAccount()
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const updateAccountByContent = (newContent) => {
        const inbox_id = newContent?._id
        if (inbox_id) {
            setLinkedAccounts(previousValue => previousValue.map(inbox => inbox?._id === inbox_id ? { ...inbox, ...newContent } : inbox))
            if (accountConfig?._id === inbox_id) {
                setAccountConfig(previousValue => ({ ...previousValue, ...newContent }))
            }
        }
    }

    const getAssignmentHistory = (inboxId = assignmentHistoryInbox?._id, filters = assignmentHistoryFilters, page = 1) => {
        if (!inboxId) return

        setIsLoadingAssignmentHistory(true)
        api.get(`/integrations/instagram/accounts/${inboxId}/assignment-history`, {
            params: {
                account_id,
                ...(filters.dateStart ? { dateStart: filters.dateStart } : {}),
                ...(filters.dateEnd ? { dateEnd: filters.dateEnd } : {}),
                ...(filters.sources?.length ? { sources: filters.sources.join(",") } : {}),
                page,
                limit: 50,
            }
        }).then(response => {
            const data = response?.data?.data || { assignments: [], pagination: {} }
            setAssignmentHistory(previousValue => ({
                assignments: page > 1 ? [...(previousValue?.assignments || []), ...(data.assignments || [])] : data.assignments || [],
                pagination: data.pagination || {}
            }))
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoadingAssignmentHistory(false))
    }

    const handleShowAssignmentHistory = (inbox) => {
        const filters = getDefaultAssignmentFilters()
        setAssignmentHistoryInbox(inbox)
        setAssignmentHistoryFilters(filters)
        setShowAssignmentHistoryModal(true)
        getAssignmentHistory(inbox?._id, filters)
    }

    const handleCloseAssignmentHistory = () => {
        setShowAssignmentHistoryModal(false)
        setAssignmentHistoryInbox({})
        setAssignmentHistory({ assignments: [], pagination: {} })
    }

    const handleAssignmentHistoryPeriodChange = (dateStart, dateEnd) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, dateStart: dateStart || "", dateEnd: dateEnd || "" }))
    }

    const handleAssignmentHistorySourceChange = (sources) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, sources: sources || [] }))
    }

    const handleLoadMoreAssignmentHistory = () => {
        const nextPage = Number(assignmentHistory?.pagination?.page || 1) + 1
        getAssignmentHistory(assignmentHistoryInbox?._id, assignmentHistoryFilters, nextPage)
    }

    const getAllChatBots = () => {
        api.get("/integrations/whatsapp/chatbots").then(response => {
            setChatBots(response?.data?.data || [])
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    const handleLoginBM = () => {
        const clientId = process.env.REACT_APP_INSTAGRAM_APP_ID
        if (!clientId) {
            toast.error("O ID do app do Instagram não está configurado. Defina REACT_APP_INSTAGRAM_APP_ID.")
            return
        }
        const redirectUri = getInstagramRedirectUri()
        const state = encodeURIComponent(JSON.stringify({ account_id }))
        const scope = encodeURIComponent([
            "instagram_business_basic",
            "instagram_business_manage_messages",
        ].join(","))
        const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${scope}&state=${state}`
        window.location.href = authUrl
    }

    const getInstagramRedirectUri = () => {
        return `${window.location.origin}/instagram/oauth/callback`
    }

    const sortByName = (a, b) => (a.name || "").localeCompare(b.name || "")

    const getAssignmentSourceLabel = (source) => {
        const labels = {
            new_conversation: "Nova conversa",
            manual: "Manual",
            ai_handoff: "IA para humano",
            management: "Gestão em massa",
            bulk_action: "Ação em lote",
            access_request: "Liberação de acesso",
            chat_start: "Início de atendimento",
        }

        return labels[source] || "Atribuição"
    }

    const getAssignmentRuleLabel = (assignment) => {
        const rule = assignment?.assignment_rule
        const owner = assignment?.owner

        if (rule?.users?.includes("auto") && rule?.round_robin?.mode === "custom") return "Rodízio personalizado"
        if (rule?.users?.includes("auto") || assignment?.round_robin_selected_user_id) return "Rodízio automático"
        if (rule?.assign_to === "teamAndRole" || owner?.assignTo === "teamAndRole") return "Equipe/Cargo"
        if (rule?.users?.length || owner?.assignTo === "users") return "Usuário(s)"

        return "Regra não registrada"
    }

    const getAssignmentReasonLabel = (assignment) => {
        const context = assignment?.assignment_context
        const reasons = {
            lead_owner_match: "Responsável do lead correspondente",
            inbox_default_rule: "Regra padrão da caixa",
        }

        if (context?.reason_label) return context.reason_label
        if (context?.reason && reasons[context.reason]) return reasons[context.reason]
        if (assignment?.source === "new_conversation") return `Regra padrão: ${getAssignmentRuleLabel(assignment)}`
        if (assignment?.source === "manual") return "Atribuição manual"
        if (assignment?.source === "management") return "Alteração em massa"
        if (assignment?.source === "bulk_action") return "Ação em lote"
        if (assignment?.source === "ai_handoff") return "Transferência da IA"
        if (assignment?.source === "access_request") return "Solicitação aprovada"
        if (assignment?.source === "chat_start") return "Usuário assumiu o atendimento"

        return getAssignmentRuleLabel(assignment)
    }

    const getAssignmentTargetLabel = (assignment) => {
        const assignedUsers = assignment?.assigned_users?.map(user => user.name).filter(Boolean) || []
        const team = assignment?.team?.name
        const role = assignment?.role?.name

        if (assignedUsers.length) return assignedUsers.join(", ")
        if (team && role) return `${team} / ${role}`
        if (team) return team
        if (role) return role

        return "Destino não registrado"
    }

    const getAssignmentEligibleLabel = (assignment) => {
        const eligibleUsers = assignment?.eligible_users?.map(user => user.name).filter(Boolean) || []
        return eligibleUsers.length ? eligibleUsers.join(", ") : "-"
    }

    const getInstagramTokenLabel = (account) => {
        const token = account?.metadata?.instagram_token
        if (token?.reconnect_required || account?.metadata?.instagram_reconnect_required) {
            return "Reconexão necessária"
        }
        if (token?.refresh_failed) {
            return "Renovação falhou"
        }
        if (Number.isFinite(Number(token?.days_to_expire))) {
            return `Token expira em ${token.days_to_expire} dia(s)`
        }
        return ""
    }

    return (
        <div className={styles.container}>
            <div className="page-back-row">
                <BackButton fallback={`/${account_id}/integrations/chat`} />
            </div>
            <div className={styles.content}>
                <div className={styles.card}>
                    <div className={styles.header}>
                        <RiInstagramLine style={{ color: "#e4405f" }} />
                        <span>Instagram Direct</span>
                        <FormGroup>
                            <Button variant="primary" onClick={handleLoginBM}>Adicionar nova conta</Button>
                        </FormGroup>
                    </div>
                    <div className={styles.body}>
                        <FormGroup labelText="Contas Conectadas">
                            {linkedAccounts.length > 0 && linkedAccounts.sort(sortByName).map((account) => (
                                <InboxCard
                                    key={account._id}
                                    name={account.name || account?.metadata?.instagram_username || "-"}
                                    phone={[account?.metadata?.instagram_id ? `ID do Instagram: ${account.metadata.instagram_id}` : "", getInstagramTokenLabel(account)].filter(Boolean).join(" • ")}
                                    status={account.status}
                                    image={account?.metadata?.instagram_picture_url}
                                    imageAlt={`Imagem do Instagram ${account.name || account?.metadata?.instagram_username || ""}`}
                                    icon={<RiInstagramLine />}
                                    platform="direct"
                                    actions={[
                                        {
                                            label: "Configurar",
                                            onClick: () => handleShowModalAccount(account._id),
                                            alwaysVisible: true
                                        },
                                        {
                                            label: "Histórico de atribuição",
                                            onClick: () => handleShowAssignmentHistory(account),
                                            alwaysVisible: true
                                        },
                                        {
                                            label: "Renovar token",
                                            onClick: () => handleRefreshToken(account),
                                            alwaysVisible: true
                                        },
                                        {
                                            label: "Reconectar",
                                            onClick: handleLoginBM,
                                            alwaysVisible: true
                                        },
                                        {
                                            label: "Desconectar",
                                            type: "danger",
                                            onClick: () => { setAccountDisconect(account); setShowModalDisconect(true) }
                                        }
                                    ]}
                                />
                            ))}
                            {linkedAccounts.length === 0 && <span>Nenhuma conta conectada até o momento!</span>}
                        </FormGroup>
                        <FormGroup labelText="Contas Disponíveis (Não Conectadas)">
                            {availableAccounts.length > 0 && availableAccounts.sort(sortByName).map((account, index) => (
                                <div className={styles.groupAccount} key={index}>
                                    <div className={styles.accountAvatar}>
                                        <ImageWithFallback
                                            src={account?.picture_url}
                                            alt="Imagem de Perfil do Instagram"
                                            functionError={() => <div className={styles.accountAvatarFallback}><RiInstagramLine style={{ color: "#e4405f" }} /></div>}
                                        />
                                    </div>
                                    <div className={styles.title}>
                                        <span>{account.name || account.username || "-"}</span>
                                        {account.username && <span className={styles.number}>@{String(account.username).replace(/^@/, "")}</span>}
                                        {account.instagram_id && <span className={styles.number}>ID do Instagram: {account.instagram_id}</span>}
                                    </div>
                                    <Button variant="primary" onClick={() => { setAccountConect(account); setShowModalConfirm(true) }}>Conectar</Button>
                                </div>
                            ))}
                            {hasLoadingAvailable && availableAccounts.length === 0 && <span>Nenhuma conta disponível para conexão!</span>}
                            {!hasLoadingAvailable && <Button variant="primary" onClick={getAllNotLinkedAccounts}>Listar contas disponíveis</Button>}
                        </FormGroup>
                    </div>
                </div>
            </div>
            {showModalConfirm &&
                <ModalConfirm
                    closeModal={handleCloseModalConfirm}
                    icon={<MdOutlineCheck />}
                    title="Deseja realmente conectar a conta?"
                    description={`Ao conectar a conta ${accountConect.name || accountConect.username} você concorda com os detalhes abaixo`}
                    text="Após a conexão, as mensagens recebidas no Instagram Direct serão direcionadas automaticamente para nossa plataforma. Na próxima tela será possível definir algumas configurações adicionais!"
                    onSubmit={() => handleConectAccount(accountConect)}
                />
            }
            {showModalDisconect &&
                <ModalConfirm
                    closeModal={handleCloseModalDisconect}
                    icon={<AiOutlineDisconnect />}
                    title="Deseja realmente desconectar a conta?"
                    description={`Ao desconectar a conta ${accountDisconect.name || accountDisconect?.metadata?.instagram_username} você concorda com os detalhes abaixo`}
                    text="Após a desconexão, as mensagens enviadas a essa conta deixarão de ser direcionadas para nossa plataforma."
                    onSubmit={() => handleDisconectAccount(accountDisconect)}
                />
            }
            {showAssignmentHistoryModal &&
                <Modal
                    icon={<MdHistory />}
                    title="Histórico de atribuição"
                    description={`Caixa de entrada ${assignmentHistoryInbox?.name || ""}`}
                    closeModal={handleCloseAssignmentHistory}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.assignmentHistoryModal}>
                        <div className={styles.assignmentHistoryFilters}>
                            <DatePicker
                                multiple={true}
                                name="Período"
                                dateStart={assignmentHistoryFilters.dateStart || ""}
                                dateEnd={assignmentHistoryFilters.dateEnd || ""}
                                onChange={handleAssignmentHistoryPeriodChange}
                            />
                            <div className={styles.assignmentHistorySourceFilter}>
                                <div>
                                    <span>Origem</span>
                                    <InfoTooltip text={ASSIGNMENT_SOURCE_TOOLTIP} preferredPosition="bottom" />
                                </div>
                                <Select
                                    name="Todas as origens"
                                    placeholder="Todas as origens"
                                    options={ASSIGNMENT_SOURCE_OPTIONS}
                                    selected={assignmentHistoryFilters.sources || []}
                                    multiple={true}
                                    onChange={handleAssignmentHistorySourceChange}
                                />
                            </div>
                            <Button variant="secondary" onClick={() => getAssignmentHistory()}>
                                Filtrar
                            </Button>
                        </div>
                        <div className={styles.assignmentHistorySummary}>
                            <strong>{formatNumber(assignmentHistory?.pagination?.total || assignmentHistory?.assignments?.length || 0)}</strong>
                            <span>atribuições encontradas no período selecionado</span>
                        </div>
                        <div className={styles.assignmentHistoryTable}>
                            <div className={styles.assignmentHistoryHeader}>
                                <span>Data</span>
                                <span>Destino</span>
                                <span>Motivo</span>
                                <span>Regra</span>
                                <span>Elegíveis</span>
                                <span>Origem</span>
                                <span>Conversa</span>
                            </div>
                            {assignmentHistory?.assignments?.map(assignment => (
                                <div key={assignment._id} className={styles.assignmentHistoryRow}>
                                    <span>{formatDateTime(assignment.created_at)}</span>
                                    <strong>{getAssignmentTargetLabel(assignment)}</strong>
                                    <span>{getAssignmentReasonLabel(assignment)}</span>
                                    <span>{getAssignmentRuleLabel(assignment)}</span>
                                    <span>{getAssignmentEligibleLabel(assignment)}</span>
                                    <span>{getAssignmentSourceLabel(assignment.source)}</span>
                                    <span>
                                        {assignment?.conversation?.url ?
                                            <a href={`/${account_id}/chat/${assignment.conversation._id}`} target="_blank" rel="noreferrer">
                                                Abrir <MdOpenInNew />
                                            </a>
                                            : "-"
                                        }
                                    </span>
                                </div>
                            ))}
                            {!assignmentHistory?.assignments?.length && !isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>
                                    Nenhuma atribuição registrada nesse período.
                                </div>
                            }
                            {isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>
                                    Carregando histórico...
                                </div>
                            }
                        </div>
                        {assignmentHistory?.pagination?.has_more &&
                            <div className={styles.assignmentHistoryLoadMore}>
                                <Button variant="secondary" onClick={handleLoadMoreAssignmentHistory} disabled={isLoadingAssignmentHistory}>
                                    {isLoadingAssignmentHistory ? "Carregando..." : "Carregar mais"}
                                </Button>
                            </div>
                        }
                    </div>
                </Modal>
            }
            {showModalAccount &&
                <ModalInbox
                    inbox={accountConfig}
                    teams={teams}
                    roles={roles}
                    users={users}
                    usersWithAuto={[{ id: "auto", value: "Rodízio Automático" }, ...users]}
                    chatBots={chatBots}
                    funnels={funnels}
                    closeModal={handleCloseModalAccount}
                    onSubmit={handleUpdateAccount}
                />
            }
            {isLoading && <Loading fullAccount={true} />}
        </div>
    )
}

export default InstagramDirectIntegration
